import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import { fetchArtifactTypes, selectSortedArtifactTypes } from '../store/slices/artifactTypeSlice';

export const useArtifactTypes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const artifactTypes = useSelector(selectSortedArtifactTypes);
  const loading = useSelector((state: RootState) => state.artifactTypes.loading);
  const error = useSelector((state: RootState) => state.artifactTypes.error);

  useEffect(() => {
    // Automatically fetch if not loaded and not currently loading
    if (artifactTypes.length === 0 && !loading) {
      void dispatch(fetchArtifactTypes());
    }
  }, [dispatch, artifactTypes.length, loading]);

  return { artifactTypes, loading, error };
};

